export default __webpack_public_path__ + "static/media/background-3.0619d3f7.jpg";